import TaxInformationFields from '@/components/TaxInformation/TaxInformationFields';
import { useTaxInformationYupForm } from '@/components/TaxInformation/hooks';

import SectionForm from '../SectionForm';

function TaxInfo({ title = '', description = '' }) {
	const { methods, loading, onSubmit, typeValue, countryValue } =
		useTaxInformationYupForm({
			onSuccess: () => {}
		});

	return (
		<SectionForm
			title={title}
			description={description}
			methods={methods}
			onSubmit={onSubmit}
			loading={loading}
		>
			<TaxInformationFields
				typeValue={typeValue}
				countryValue={countryValue}
			/>
		</SectionForm>
	);
}

export default TaxInfo;
